export const isValidUUID = (uuid) => {
    const regex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

    return regex.test(uuid);
};

export const isValidIP = (ip) => {
    const regex = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
    const match = ip.match(regex);

    if (!match) return false;

    return match.slice(1).every((num) => {
        const n = parseInt(num, 10);
        return n >= 0 && n <= 255 && String(n) === num;
    });
};

export const isValidMacAddress = (mac, needsToBeValued = false) => {
    if (!needsToBeValued && !mac) return true;

    const regex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
    return regex.test(mac);
};
